import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SlideshowIcon(props: IconProps) {
    return <Icon {...props} iconKey={"slideshow"}/>
}
